import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,
        DownloadTemplate,DynamicListArea,BulkEdit,
        LoadGraphic,AddListItem,Step} from '../components/Common';
import {Input,Button,CheckboxList, TextButton} from '../components/Input';
import u from '../utilities/Utilities';
import "../styles/appointment-list.scss";


export default class AppointmentList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Appointment List",
        permission:"appointment",  //Accepts combined permission module as well
        //combinedField:"",          //Used when permission exists in a combined field
        url:"/appointment-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/add-appointment-entry",
        deleteURL:"/api/delete-appointment-entries",
        spreadsheetURL:"/api/generate-appointment-spreadsheet",
        overviewURL:"/api/get-all-appointment-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"appointment-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        onPopup:(content)=>{this.r['layout'].onPopup(content)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        download:{component:DownloadTemplate,props:{skipParams:true}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:(permissions.create==2)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ]
        })
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu ref={(ref)=>{this.r['pageMenu']=ref}}
                          buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index}
                                          index={index}
                                          content={content}
                                          onChange={onChange}
                                          onContentChange={onContentChange}
                                          registerReference={registerRef}
                                          permissions={this.state.permissions}
                                          settings={this.settings}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{

    state={
        error:"",
        step:"view",
        loading:false,
        loadText:"",
        exclude:[],
    };

    onRemoveConfirm=null;

    onConfirmLogic=(base)=>{
        this.editIndex=-1;
        this.baseCriterion=base;
        this.setState({step:"selection",error:"",exclude:[]});
    }

    onConfirmSelection=async (selection)=>{
        const {content}=this.props;
        let newValue = JSON.parse(JSON.stringify(content.criterion));
        if(this.editIndex>=0){
            newValue[this.editIndex].selected = newValue[this.editIndex].selected.concat(selection);
        }
        else{
            this.baseCriterion.selected=selection;
            const newCriterion = Object.assign({},this.baseCriterion);
            newValue.push(newCriterion);
        }
        this.setState({loading:true,loadText:"Updating..."});
        try{
            await u.postAsync({
                url:"/api/update-appointment-info",
                data:{
                    id:content.appointmentID,
                    oldValue:content.criterion,
                    newValue:newValue,
                    field:"criterion"
                }
            });
            this.props.onChange(newValue,"criterion",this.props.index);
            this.setState({step:"view",error:"",loading:false});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
        
    }

    onDeleteCriteria=(index)=>{
        const {content}=this.props;
        this.onRemoveConfirm=async ()=>{
            this.setState({loading:true,loadText:"Deleting..."});
            let newValue = JSON.parse(JSON.stringify(content.criterion));
            newValue.splice(index,1);
            await u.postAsync({
                url:"/api/update-appointment-info",
                data:{
                    id:content.appointmentID,
                    oldValue:content.criterion,
                    newValue:newValue,
                    field:"criterion"
                }
            });
            this.props.onChange(newValue,"criterion",this.props.index);
            this.setState({step:"view",error:"",loading:false});
        }
        this.setState({
            step:"remove",
            removeMessage:"Confirm Remove Criteria " + (index+1)
        });
    }

    onRemoveCriteriaSelect=(index,crit)=>{
        let {content}=this.props;
        this.onRemoveConfirm=async ()=>{
            this.setState({loading:true,loadText:"Deleting..."});
            let newValue = JSON.parse(JSON.stringify(content.criterion));
            newValue[index].selected.splice(crit,1);
            await u.postAsync({
                url:"/api/update-appointment-info",
                data:{
                    id:content.appointmentID,
                    oldValue:content.criterion,
                    newValue:newValue,
                    field:"criterion"
                }
            });
            this.props.onChange(newValue,"criterion",this.props.index);
            this.setState({step:"view",error:"",loading:false});
        }
        this.setState({
            step:"remove",
            removeMessage:"Confirm Remove " + content.criterion[index].selected[crit].label
        });
    }

    onAddSelected=(index)=>{
        this.editIndex=index;
        const {content}=this.props;
        this.baseCriterion=content.criterion[index];
        const exclude = content.criterion[index].selected;
        this.setState({exclude:exclude,step:"selection",error:""});
    }

    render=()=>{
        const {content,settings,permissions} = this.props;
        const {step,exclude}=this.state;
        const canEdit= (permissions.update==2);

        return (
            <div style={{textAlign:"center"}}>

                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={step=="view"}>
                    <DynamicListArea listLabel={settings.listLabel}
                                    permission={settings.permission}
                                    content={content}
                                    onChange={this.props.onChange}
                                    index={this.props.index}
                                    />
                    
                    <div>
                    {
                        (content.criterion.length)
                            ?
                            content.criterion.map((item,index)=>{
                                return (
                                    <div className='criteria-container' key={index}>
                                        <h3>Criteria {index+1} - {item.type} {item.field} </h3>
                                        
                                        <CheckboxList canRemove={canEdit}
                                                      headers={[{label:item.type + " " + item.field + " (" + item.logic + ")",value:"label"}]}
                                                      content={item.selected}
                                                      onRemove={(critIndex)=>{this.onRemoveCriteriaSelect(index,critIndex)}}
                                                      style={{width:"400px"}}
                                                      />

                                        {
                                            (canEdit)
                                                ?
                                                <div style={{margin:"20px auto"}}>
                                                    <TextButton onClick={()=>{this.onDeleteCriteria(index)}}>Delete Criteria</TextButton>
                                                    <TextButton onClick={()=>{this.onAddSelected(index)}}>Add Criteria</TextButton>
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                                )
                            })
                            :
                            <div className='list-placeholder'>
                                <b>No Criteria Attached</b>
                                <div>Click below to add critera</div>
                            </div>
                    }
                    </div>

                    {
                        (canEdit)
                            ?
                            <div style={{margin:"20px auto"}}>
                                <Button onClick={()=>{this.setState({step:"add-logic",error:""})}}>Add Criteria</Button>
                            </div>
                            :
                            null
                    }
                </Step>

                <Step active={step=="add-logic"}>
                    <div style={{position:"relative",fontSize:"14px"}}>
                        <h3>Confirm Criteria Logic</h3>
                        <AddCriteriaLogic onBack={()=>{this.setState({step:"view",error:""})}}
                                        onConfirm={this.onConfirmLogic}
                                        />
                    </div>
                </Step>

                <Step active={step=="selection"}>
                    <div style={{position:"relative",fontSize:"14px"}}>
                        <h3>Add Criteria Targets</h3>
                        <AddCriteriaSelection base={this.baseCriterion}
                                              onBack={()=>{this.setState({step:((this.editIndex >= 0) ? "view" : "add-logic"),error:""})}}
                                            onConfirm={this.onConfirmSelection}
                                            exclude={exclude}
                                            style={{fontSize:"12px",width:"600px"}}
                                            />
                    </div>
                </Step>

                <Step active={step=="remove"}>
                    <div style={{padding:"20px 0"}}>
                        <h2 className='text-negative'>{this.state.removeMessage}</h2>
                        <div className='list-segment-note'>Note. This action cannot be undone</div>
                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onRemoveConfirm}>Confirm</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{

    settings={
        addType:0,
        addURL:"/api/add-appointment-entry",
    };

    r={};

    state={
        step:"add",
        entryData:{
            criterion:[],
        },
        options:{},
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:""});
        }
    }

    componentDidMount=()=>{
        this.getOptions();

        this.show(this.props.active);
    }

    getOptions=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-options",
                data:{
                    keys:[
                        "entryType"
                    ]
                }
            });

            this.setState({options:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirm=(fields)=>{
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        const {entryData}=this.state;
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onValidated({...entryData,...data});
    }

    onComplete=()=>{
        this.setState({
            entryData:{criterion:[]},
            step:"add"
        });

        if(this.props.onComplete){
            this.props.onComplete();
        }
    }

    onChange=(value,label,index)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onConfirmLogic=(base)=>{
        this.editIndex=-1;
        this.baseCriterion=base;
        this.setState({step:"selection",error:"",exclude:[]});
    }

    onConfirmSelection=(selection)=>{
        const {entryData}=this.state;
        console.log(this.editIndex);
        if(this.editIndex>=0){
            entryData.criterion[this.editIndex].selected = entryData.criterion[this.editIndex].selected.concat(selection);
        }
        else{
            this.baseCriterion.selected=selection;
            const newCriterion = Object.assign({},this.baseCriterion);
            entryData.criterion.push(newCriterion);
        }
        this.setState({entryData:entryData,step:"add",error:""});
    }

    onDeleteCriteria=(index)=>{
        const {entryData}=this.state;
        entryData.criterion.splice(index,1);
        this.setState({entryData:entryData});
    }

    onRemoveCriteriaSelect=(index,crit)=>{
        let {entryData}=this.state;
        entryData.criterion[index].selected.splice(crit,1);
        this.setState({entryData:entryData});
    }

    onAddSelect=(index)=>{
        this.editIndex=index;
        const {entryData}=this.state;
        this.baseCriterion=entryData.criterion[index];
        const exclude = entryData.criterion[index].selected;
        this.setState({exclude:exclude,step:"selection",error:""});
    }

    render=()=>{
        const {loading,loadText,step,options,entryData,exclude}=this.state;

        const fields=[
            {dataType:"box",label:"Appointment Title",field:"appointmentTitle",rules:{required:true}},
        ];

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={false}
                         inList={this.props.miniList}
                         onToggleForm={this.props.onToggleForm}
                         >

                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="add"}>
                        <h3>Complete the following fields to create entry</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                    options:item.options,
                                                    value:entryData[item.field]
                                               }}
                                               fields={{
                                                ...item,
                                                onChange:this.onChange
                                               }}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }

                        <div style={{margin:"30px auto"}}>
                            {
                                (entryData.criterion.length > 0)
                                    ?
                                    entryData.criterion.map((item,index)=>{
                                        return (
                                            <div className='criteria-container' style={{fontSize:"12px"}} key={index}>
                                                <h3>Criteria {index+1} - {item.type} {item.field} </h3>
                                                
                                                <CheckboxList canRemove={true}
                                                              headers={[{label:item.type + " " + item.field + " (" + item.logic + ")",value:"label"}]}
                                                              content={item.selected}
                                                              onRemove={(critIndex)=>{this.onRemoveCriteriaSelect(index,critIndex)}}
                                                              style={{width:"400px"}}
                                                              />

                                                <div style={{margin:"20px auto"}}>
                                                    <TextButton onClick={()=>{this.onDeleteCriteria(index)}}>Delete Criteria</TextButton>
                                                    <TextButton onClick={()=>{this.onAddSelect(index)}}>Add {item.field}</TextButton>
                                                </div>
                                            </div>
                                        )
                                    })
                                    
                                    :
                                    <div className='list-placeholder'>
                                        <h3 style={{margin:"0"}}>No Criteria Added</h3>
                                        <div>Criteria is optional and can be added later on</div>
                                    </div>
                            }
                            <div style={{margin:"20px auto",fontSize:"14px"}}>
                                <TextButton onClick={()=>{this.setState({step:"add-logic",error:""})}}>Add Criteria</TextButton>
                            </div>
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirm(fields)}}>Confirm</Button>
                        </div>
                    </Step>

                    <Step active={step=="add-logic"}>
                        <h3>Confirm Criteria Logic</h3>
                        <AddCriteriaLogic ref={(ref)=>{this.r['logic']}}
                                          onBack={()=>{this.setState({step:"add",error:""})}}
                                          onConfirm={this.onConfirmLogic}
                                          />
                    </Step>

                    <Step active={step=="selection"}>
                        <h3>Add Criteria Targets</h3>
                        <AddCriteriaSelection ref={(ref)=>{this.r['selection']=ref}}
                                              base={this.baseCriterion}
                                              onBack={()=>{this.setState({step:((this.editIndex >= 0) ? "add" : "add-logic"),error:""})}}
                                              onConfirm={this.onConfirmSelection}
                                              style={{fontSize:"12px"}}
                                              exclude={exclude}
                                              />
                    </Step>
                </div>

            </AddListItem>
        )
    }
}

class AddCriteriaLogic extends React.Component{

    r={};

    state={
        logicOptions:[
            {value:"All",label:"All"},
            {value:"Any",label:"Any"},
        ],
        fieldOptions:[
            {value:"Traits",label:"Traits"},
            {value:"Qualifications",label:"Qualifications"},
        ],
        typeOptions:[
            {value:"Required",label:"Required"},
            {value:"Disqualifying",label:"Disqualifying"},
        ],
        options:{
            traitType:[],
        },
        traitCategoryOptions:[],
        entryData:{
            field:"Traits",
        }
    }

    componentDidMount=()=>{
        this.getOptions();
        this.getTraitCategory();
    }

    getOptions=async ()=>{
        try{
            const response = await u.postAsync({
                url:"/api/get-options",
                data:{
                    keys:["traitType"]
                }
            });
            response.data.traitType.unshift({value:"All",label:"All"});
            this.setState({options:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    getTraitCategory=async ()=>{
        try{
            const response = await u.postAsync({url:"/api/get-trait-categories-options"});
            response.data.unshift({value:"All",label:"All"});
            this.setState({traitCategoryOptions:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    validate=(fields)=>{
        this.setState({error:""});
        let data={};
        const keys=fields.map((item)=>{return item.field});
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        this.props.onConfirm(data);
    }

    onChange=(value,label,index)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    render=()=>{
        const {logicOptions,fieldOptions,typeOptions,traitCategoryOptions,options,entryData}=this.state;
        const addOn={
            "Traits":[
                {dataType:"select",label:"Trait Type",field:"traitType",options:options.traitType},
                {dataType:"select",label:"Trait Category",field:"traitCategory",options:traitCategoryOptions},
            ],
            "Qualifications":[]
        }
        const fields=[
            {dataType:"select",label:"Logic",field:"logic",options:logicOptions,info:"<b>Any</b><br/>Criteria to require or disqualify is met, when <b>any</b> of the selected traits/training are detected.<br/><br/><b>All</b><br/>Criteria to require or disqualify is met when <b>all</b> the selected traits/training are detected."},
            {dataType:"select",label:"Type",field:"type",options:typeOptions},
            {dataType:"select",label:"Field",field:"field",options:fieldOptions},
        ].concat(addOn[entryData.field]);

        return (
            <div>
                {
                    fields.map(
                        (item,index)=>{
                            return (
                                <Input key={index}
                                       ref={(ref)=>{this.r[item.field]=ref}}
                                       values={{
                                         options:item.options,
                                         value:entryData[item.field]
                                       }}
                                       fields={{
                                            ...item,
                                            onChange:this.onChange
                                       }}
                                       rules={item.rules}
                                       labelStyle={{width:"40%"}}
                                       inputStyle={{width:"57%"}}
                                       />
                            )
                        }
                    )
                }

                <div style={{margin:"30px auto"}}>
                    <div className='page-error'>{this.state.error}</div>
                    <Button onClick={()=>{this.setState({error:""}); this.props.onBack()}}>Back</Button>
                    <Button onClick={()=>{this.validate(fields)}}>Next</Button>
                </div>
            </div>
        )
    }
}

class AddCriteriaSelection extends React.Component{

    r={};

    state={
        options:[],
    }

    componentDidMount=()=>{
        console.log("component mounting",this.props.base);
        this.getSelection(this.props.base);
    }

    getSelection=async ({logic,type,field,traitType,traitCategory})=>{
        let api="/api/get-trait-options";
        console.log("field",field);
        if(field=="Qualifications"){
            api="/api/get-qualification-options";
        }
        try{
            const response = await u.postAsync({url:api,data:{type:traitType,category:traitCategory}});
            //Remove exclude
            let options=response.data;
            const {exclude}=this.props;
            for(var i=0; i<exclude.length; i++){
                for(var j=options.length-1; j>=0; j--){
                    if(options[j].value == exclude[i].value){
                        options.splice(j,1);
                    }
                }
            }

            this.setState({options:options,field:field,type:type,logic:logic});
        }
        catch(e){
            const {error,status}=this.state;
            this.setState({error:error});
        }
    }

    validate=()=>{
        const selected=this.r['input'].getInterest();
        if(selected.length == 0){
            this.setState({error:"Please select at least 1 entry"});
            return 0;
        }
        const r= selected.filter((item)=>{return item.selected}).map((item)=>{
            delete item.selected;
            return item;
        });

        this.props.onConfirm(r);
    }

    render=()=>{
        const {options,field,type,logic}=this.state;
        return (
            <div>
                <CheckboxList ref={(ref)=>{this.r['input']=ref}}
                              content={options}
                              headers={[{label:type+" " + field + " ("+logic+")",value:"label"}]}
                              checkbox={true}
                              searchable={true}
                              style={this.props.style}
                              />

                <div style={{margin:"30px auto"}}>
                    <div className='page-error'>{this.state.error}</div>
                    <Button onClick={()=>{this.setState({error:""}); this.props.onBack()}}>Back</Button>
                    <Button onClick={this.validate}>Confirm</Button>
                </div>
            </div>
        )
    }
}
